import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import cx from 'clsx';
import { IconFileAttachmentOutlined } from '@repo/monochrome-icons';
import { ProgressBar } from '@repo/design-system-kit';
import styles from './uploading.module.css';

interface UploadingProps extends ComponentPropsWithoutRef<'div'> {
  className?: string;
  progress?: number;
  title?: string;
  hasPreview?: boolean;
}

export function Uploading({
  className,
  progress,
  title,
  hasPreview,
  ...props
}: UploadingProps): ReactNode {
  return (
    <div className={cx(styles.container, className)} data-testid="uploading" {...props}>
      <div className={styles.iconContainer}>
        <IconFileAttachmentOutlined />
      </div>
      <div className={styles.content}>
        <div
          className={cx(styles.title, 'body-standard', hasPreview && styles.previewText)}
          data-testid="file-name"
        >
          {title}
        </div>
        <div className={styles.progressContainer}>
          <ProgressBar
            className={styles.progressBar}
            maxValue={100}
            minValue={0}
            type="primary"
            value={progress}
            wrapperClassName={styles.progressBarWrapper}
          />
          {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx -- percentage symbol not translatable */}
          <div className={cx(styles.description, 'body-standard')}>{progress}%</div>
        </div>
      </div>
    </div>
  );
}
